import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_authed/_sidebar/accounting/')({
    beforeLoad: () => {
        throw redirect({ to: '/accounting/expenses' })
    },
})
